module.exports = __webpack_public_path__ + "img/loader.89fabc53.svg";